var map = {
	"./0.png": "af2d",
	"./1.png": "d68a",
	"./2.png": "35aa",
	"./3.png": "8bf3",
	"./4.png": "02a3",
	"./5.png": "ffdb",
	"./6.png": "33bc",
	"./7.png": "d2e2",
	"./8.png": "aa68",
	"./9.png": "f2ce"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "87a2";